import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import project_logo from "../images/project_logo.png";
import lab_logo from "../images/lab_logo.png";
import iith_logo from "../images/iith_logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const getLinkClasses = (path) =>
    [
      "px-4 py-1 rounded-full text-[15px] font-semibold transition-all",
      "hover:bg-slate-200 hover:text-gray-900 hover:scale-[1.02]",
      "flex items-center justify-center",
      isActive(path) ? "bg-slate-300 text-gray-900" : "text-gray-700",
    ].join(" ");

  return (
    <nav className="bg-white border-b border-gray-100 shadow-sm sticky top-0 z-50">
      <div className="max-w-9xl mx-auto px-7 py-3 flex items-center justify-between h-[72px]">
        {/* LEFT: LOGO + TITLE */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src={project_logo}
            alt="Origenomi Logo"
            className="h-12 w-12 object-contain"
          />
          <h1 className="text-2xl font-extrabold tracking-tight text-gray-900 select-none">
            <span className="text-green-600">Ori</span>
            <span className="text-purple-500">genomi</span>
          </h1>
        </Link>

        {/* CENTER NAV LINKS – DESKTOP */}
        <div className="hidden md:flex bg-slate-100 rounded-full px-4 py-2 gap-5">
          <Link to="/" className={getLinkClasses("/")}>
            Home
          </Link>
          <Link to="/search" className={getLinkClasses("/search")}>
            Web Server
          </Link>
          <Link to="/database" className={getLinkClasses("/database")}>
            Database
          </Link>
          <Link to="/about" className={getLinkClasses("/about")}>
            About
          </Link>
          <Link to="/contact" className={getLinkClasses("/contact")}>
            Contact
          </Link>
          <Link
            to="/other-resources"
            className={getLinkClasses("/other-resources")}
          >
            Other Resources
          </Link>
        </div>

        {/* RIGHT LOGOS */}
        <div className="hidden md:flex items-center gap-2">
          <img
            src={lab_logo}
            alt="Lab logo"
            className="h-14 w-14 object-contain hover:opacity-80 transition"
          />
          <img
            src={iith_logo}
            alt="IIT Hyderabad logo"
            className="h-14 w-26 object-contain hover:opacity-80 transition"
          />
        </div>

        {/* MOBILE TOGGLE BUTTON */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-gray-800"
        >
          {isOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-md animate-slideDown">
          <div className="px-4 py-4">
            {/* Group pill for all links on mobile too */}
            <div className="bg-slate-100 rounded-2xl p-3 flex flex-col gap-2">
              <Link
                to="/"
                className={getLinkClasses("/")}
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/search"
                className={getLinkClasses("/search")}
                onClick={() => setIsOpen(false)}
              >
                Search
              </Link>
              <Link
                to="/database"
                className={getLinkClasses("/database")}
                onClick={() => setIsOpen(false)}
              >
                Database
              </Link>
              <Link
                to="/about"
                className={getLinkClasses("/about")}
                onClick={() => setIsOpen(false)}
              >
                About
              </Link>
              <Link
                to="/contact"
                className={getLinkClasses("/contact")}
                onClick={() => setIsOpen(false)}
              >
                Contact
              </Link>
              <Link
                to="/other-resources"
                className={getLinkClasses("/other-resources")}
                onClick={() => setIsOpen(false)}
              >
                Other Resources
              </Link>
            </div>

            {/* Mobile Logos below links */}
            <div className="flex gap-4 mt-4">
              <img
                src={lab_logo}
                alt="Lab logo"
                className="h-10 w-10 object-contain"
              />
              <img
                src={iith_logo}
                alt="IIT Hyderabad logo"
                className="h-10 w-10 object-contain"
              />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
